// jarvis-cleanup: soul-файлы отключены — системный промпт агента задаётся только в разделе «Промпт»
import type { Agent } from "./types"

interface Props { agent: Agent; onSaved?: () => void }

export function SoulTab(_props: Props) {
  return (
    <p className="text-sm text-[#8d9ab0]">
      Soul-файлы отключены: системный промпт агента задаётся только в разделе «Промпт»; правила — в Конституции Джарвиса.
    </p>
  )
}
